exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---1J650 {\n  display: block; }\n\n.svgIconContainer---2Svoo {\n  width: 17px;\n  height: 17px;\n  margin: 3px; }\n\n.svgIconContainer---2Svoo svg path {\n    fill: white !important; }\n\n.button---3AnB0, .editInfo---2cr4q {\n  height: 25px;\n  background-color: #415667;\n  border-radius: 20px;\n  color: #fff;\n  font-family: Poppins, sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 27px;\n  border: 1px solid #959595;\n  margin-left: 5px;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center; }\n\n.editInfo---2cr4q {\n  display: block !important;\n  width: 40px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1J650",
	"svgIconContainer": "svgIconContainer---2Svoo",
	"button": "button---3AnB0",
	"editInfo": "editInfo---2cr4q"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/formatters/edit-info-formatter/index.scss
// module id = 1161
// module chunks = 3